import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import moment from 'moment-timezone';

import { TranslatePipe } from '@core/i18n-legacy';
import { TimePickerComponent } from '@core/time-ui';
import type { TimeData } from '@core/time-ui';
import {
  BadgeComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  FormFieldComponent,
  IconComponent,
  IconHelpComponent,
  InputComponent,
  LabelComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-due-date-form-control',
  templateUrl: './evaluation-due-date-form-control.component.html',
  styleUrl: './evaluation-due-date-form-control.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    FormFieldComponent,
    LabelComponent,
    InputComponent,
    IconComponent,
    IconHelpComponent,
    BadgeComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    DropdownComponent,
    TimePickerComponent,
    RtTooltip,
  ],
})
export class EvaluationDueDateFormControlComponent {
  public readonly value = input<TimeData | null>(null);

  public readonly valueChange = output<TimeData | null>();

  protected onTimeChange(timeData: TimeData): void {
    this.valueChange.emit({ ...timeData, time: moment(timeData.time, 'LT').format('HH:mm') });
  }

  protected clear(): void {
    this.valueChange.emit(null);
  }

  protected getTimeDataString(): string | null {
    const value = this.value();

    return value
      ? moment.tz(`${value.date}T${value.time}`, 'YYYY-MM-DDTHH:mm', value.zone).format('ll LT')
      : null;
  }
}
